import React from 'react';
import PropTypes from 'prop-types';
import BasicText from './BasicText';

const HexInput = (props) => {
    const { defaultColor = '', color = '', wrapperProps = {}, ...rest } = props;
    const prefix = (
        <>
            <div className={'prefix col'}>#</div>
            <div
                className={'color-preview hidden-xs order-last'}
                style={{
                    backgroundColor: `#${color || defaultColor}`
                }}
            />
        </>
    );
    return (
        <div className={'hex-input col-12'} {...wrapperProps}>
            <BasicText className={'col-12 col-sm-11'} {...rest} prefix={prefix} />
        </div>
    );
};

HexInput.propTypes = {
    defaultColor: PropTypes.string,
    color: PropTypes.string,
    wrapperProps: PropTypes.object
};

export default HexInput;
